<template>
  <Modal :id="id" title="Share This Video">
    <div slot="body" class="modal-body modal-form">
      <div class="form-group">
        <p>Enter the email of the person with whom you would like to share this video.</p>
        <Field type="text" name="recipient" v-model="recipient" />
      </div>
    </div>
    <div slot="footer" class="modal-footer">
      <a class="btn btn-primary" href="#" @click.prevent="send">Send</a>
      <a class="btn btn-secondary" href="#" @click.prevent="close">Cancel</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "share-video-modal",
      recipient: null
    };
  },
  methods: {
    send() {
      if (!this.recipient) {
        alert("Please enter the recipient's email address before continuing.");
        return;
      }
      this.resolve(this.recipient);
    }
  }
};
</script>